import { Spinner, useEffectivePinComponentSettings, usePinThemeContext } from '@lessonup/pin-renderer';
import { spacing, styled } from '@lessonup/ui-components';
import React from 'react';
import { SpinnerFocusMode } from '../../store/playerStoreFocusMode.types';

export type FocusModeSpinnerProps = {
  focusMode: SpinnerFocusMode;
  onSpinningChange: (isSpinning: boolean) => void;
};

export const FocusModeSpinner: React.FC<FocusModeSpinnerProps> = ({ focusMode, onSpinningChange }) => {
  const { typographies } = usePinThemeContext();
  const spinnerSettings = useEffectivePinComponentSettings('SPINNER', { settings: {} });
  const settingsBackgroundColors = spinnerSettings.sliceColors
    ? Object.values(spinnerSettings.sliceColors).map((v) => v.backgroundColor)
    : [];

  const settingsTextColors = spinnerSettings.sliceColors
    ? Object.values(spinnerSettings.sliceColors).map((v) => v.textColor)
    : [];

  const updateSpinningHandler = (isSpinning: boolean) => {
    onSpinningChange(isSpinning);
  };

  return (
    <StyledWrapper>
      <Spinner
        size={516}
        segmentTitles={focusMode.spinOptions}
        selectedIndex={focusMode.selectedIndex}
        spinCount={focusMode.spinCount}
        spinningHandler={updateSpinningHandler}
        winnerTitle={
          focusMode.spinCount > 0 && focusMode.previousDrawnOption && !focusMode.isSpinning
            ? focusMode.spinOptions[focusMode.selectedIndex]
            : undefined
        }
        typography={typographies.smallText}
        backgroundColors={settingsBackgroundColors}
        textColors={settingsTextColors}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  padding: ${spacing.size12};
`;
